import { Component, Input, Output, EventEmitter } from '@angular/core';
import { ModalController } from '@ionic/angular';

import { ViewGoalsPage } from './view-goals/view-goals.page';
import { GoalProgressPreview } from 'src/app/shared/interfaces/goal-progress.interface';

import * as moment from 'moment/moment';

@Component({
  selector: 'app-goals-progress',
  templateUrl: './goals-progress.page.html',
  styleUrls: ['./goals-progress.page.scss']
})
export class DashboardGoalsProgressPage {

  @Input() readonly cycleId: number;
  @Input() processes: Array<GoalProgressPreview> = [];

  @Output() reloadProgresses: EventEmitter<boolean> = new EventEmitter();

  constructor(
    private modalController: ModalController
  ) { }

  public async viewGoalModal(process: GoalProgressPreview) {
    const goalModal = await this._createGoalModal( this.cycleId, process.id );

    goalModal.onDidDismiss().then((dismissEvent) => {
      if (dismissEvent.data)
        this.reloadProgresses.emit(true);
    });

    goalModal.present();
  }

  private async _createGoalModal(cycleId: number, goalId: number) {
    return await this.modalController.create({
      component: ViewGoalsPage,
      cssClass: 'view-goals-modal-style',
      componentProps: {
        'goalId': goalId,
        'cycleId': cycleId,
        'allowComments': true
      }
    });
  }

  public hasStatus(process: GoalProgressPreview): boolean {
    const momentDueDate = moment(process.deadline).startOf('day');
    const momentToday = moment().startOf('day');
    const diff = moment.duration(momentDueDate.diff(momentToday)).asDays();
    if (diff > 0 && diff <= 10) {
      return true;
    }
    return false;
  }

  public getStatusColor(process: GoalProgressPreview): string {
    const momentDueDate = moment(process.deadline).startOf('day');
    const momentToday = moment().startOf('day');
    const diff = moment.duration(momentDueDate.diff(momentToday)).asDays();
    if (diff <= 10 && diff > 3) {
      return 'warning';
    } else if (diff > 0 && diff <= 3) {
      return 'danger';
    } else {
      return 'primary';
    }
  }

  public getDeadlineDateCount(process: GoalProgressPreview) {
    const momentDueDate = moment(process.deadline).startOf('day');
    const momentToday = moment().startOf('day');
    const diff = moment.duration(momentDueDate.diff(momentToday)).asDays();
    if (diff > 0 && diff <= 6) {
      return diff;
    } else {
      return Math.round(diff / 7);
    }
  }

  public getDeadlineDateTranslationKey(process: GoalProgressPreview): string {
    const momentDueDate = moment(process.deadline).startOf('day');
    const momentToday = moment().startOf('day');
    const diff = moment.duration(momentDueDate.diff(momentToday)).asDays();
    if (diff > 0 && diff <= 6) {
      return 'dashboard.deadlineDateDay';
    } else {
      return 'dashboard.deadlineDateWeek';
    }
  }

  public getProgressBarLength(process: GoalProgressPreview) {
    return { width: process.currentProgress + '%' };
  }

  public getProgressBarColor(process: GoalProgressPreview, color: string): boolean {
    const statusColor = this.getStatusColor(process);
    return color === statusColor ? true : false;
  }
}
